import React from 'react';

const HorizontalTableDivider: React.FC<{ colSpan: number }> = ({ colSpan }) => (
  <tr>
    <td colSpan={colSpan} className="dividing-line" />
  </tr>
);

export default HorizontalTableDivider;
